import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
	History,
	User,
	Hexagon,
	Database
} from 'lucide-react'

import { StatsCard } from '@/components/shared/StatsCard'
import { useObjectDetails } from '@/hooks/useApi'
import { formatBalanceInSUI, formatBalanceInMIST } from '@/utils/format';

export const ObjectDetailsPage = () => {
	const { id } = useParams<{ id: string }>()
	if (!id) {
		return <>Not Found</>
	}

	const { data: objectDetails } = useObjectDetails(id);
	console.log(objectDetails)

	const owner = useMemo(() => {
		if (!objectDetails) return null;

		if ((objectDetails.owner as any).AddressOwner) {
			return (objectDetails.owner as any).AddressOwner;
		}

		if ((objectDetails.owner as any).ObjectOwner) {
			return (objectDetails.owner as any).ObjectOwner;
		}

		if ((objectDetails.owner as any).Shared) {
			return "Shared";
		}

		return null;
	}, [objectDetails]);

	if (!objectDetails) {
		return <>Loading...</>
	}

	return (
		<div className="flex flex-col overflow-hidden w-full h-full">
			<div className='flex-1 overflow-y-auto overflow-x-hidden flex max-w-full 
  			[&::-webkit-scrollbar-track]:bg-gray-100
  			[&::-webkit-scrollbar-thumb]:bg-gray-300
  			dark:[&::-webkit-scrollbar-track]:bg-neutral-700
  			dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500'
			>
				<div className="flex flex-col w-full h-full gap-2 px-2 lg:px-4 pt-4">
					<h1 className="scroll-m-20 text-md lg:text-2xl font-bold  tracking-tight">
						Object Details
					</h1>

					<div className='grid grid-cols-1 md:grid-cols-5 gap-2'>
						<div className='md:col-span-4'>
							<StatsCard
								className='text-sm'
								valueStyleOverride='text-lg lg:text-xl overflow-hidden whitespace-nowrap text-ellipsis'
								title="Object ID"
								value={objectDetails?.objectId ?? "--"}
								icon={<Hexagon className="text-primary h-4 w-4" />}
							/>
						</div>
						<div className='md:col-span-1'>
							<StatsCard
								title="Owner"
								className='text-sm'
								valueStyleOverride='text-lg lg:text-xl overflow-hidden whitespace-nowrap text-ellipsis'
								value={owner ?? '--'}
								icon={<User className="text-primary h-4 w-4" />}
							/>
						</div>
					</div>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
						<div>
							<StatsCard
								title="Version"
								className='flex-1'
								value={objectDetails?.version ?? "--"}
								icon={<History className="text-primary h-4 w-4" />}
							/>
						</div>
						<div>
							<StatsCard
								title="Storage Rebate"
								className='flex-1'
								value={
									<>
										<div className='text-md'>
											{objectDetails?.storageRebate ? formatBalanceInSUI(Number(objectDetails?.storageRebate)) : '--'} SUI
										</div>
										<div className='text-sm text-muted-foreground'>
											{objectDetails?.storageRebate ? formatBalanceInMIST(Number(objectDetails?.storageRebate)) : '--'} MIST
										</div>
									</>
								}
								icon={<Database className="text-primary h-4 w-4" />}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}